import { getEmailTokens } from "../../../api/services/defs/internal-api";

export const emailTokensQuery = (userId: string) => ({
	queryKey: ["emailTokens", userId],
	queryFn: async () => await getEmailTokens(userId),
	meta: {
		errorMessage: "There was a problem fetching the email tokens",
	},
});
